import React, { useState, useEffect } from "react";
import Plans from "./plans";
import NewSubscriptionForm from "./new-subscription-form";
import ReNewSubscriptionForm from "./renew-subscription-form";
import { useSelector } from "react-redux";
import get from "lodash/get";

import "./subscribe-page.m.css";
import { SvgIconHandler } from "../../atoms";
import { Link } from "@quintype/components";

const SubscribePage = () => {
  const [activeTab, setActiveTab] = useState("new");
  const [selectedPlanId, setSelectedPlanId] = useState("1_YEAR_ACCESS");
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentReason, setPaymentReason] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const qtState = useSelector((state) => get(state, ["qt"]));
  const ccavenueSiteKey = get(
    qtState,
    ["config", "publisher-attributes", "ccavenue", "google_recaptcha_site_key"],
    false
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const reason = params.get("reason");
    const orderId = params.get("order_id");
    const orderStatus = params.get("order_status");
    const bankRefNo = params.get("bank_ref_n");

    if (status) {
      setPaymentStatus(status);
      setPaymentReason(
        reason || `Order ${orderId || ""} - ${orderStatus || ""}${bankRefNo ? ` (Bank Ref: ${bankRefNo})` : ""}`
      );
      setShowMessage(true);
    }
  }, []);

  useEffect(() => {
    if (ccavenueSiteKey) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${ccavenueSiteKey}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleClose = () => {
    setShowMessage(false);
    // Optionally remove query params from URL after close
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, document.title, url.toString());
  };

  return (
    <div styleName="wrapper" className="container">
      {showMessage && (
        <div
          style={{
            backgroundColor: paymentStatus === "Success" ? "#e6ffed" : "#ffe6e6",
            border: `1px solid ${paymentStatus === "Success" ? "#2ecc71" : "#e74c3c"}`,
            color: paymentStatus === "Success" ? "#2d7a46" : "#c0392b",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "20px",
            position: "relative",
            marginTop: "18px",
          }}
        >
          <strong>{paymentStatus === "Success" ? "Payment Successful 🎉" : "Payment Failed ❌"}</strong>
          <div style={{ marginTop: "8px" }}>{paymentReason}</div>

          {/* ✅ Close Button */}
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "8px",
              right: "12px",
              background: "transparent",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              color: "#888",
            }}
          >
            ×
          </button>
        </div>
      )}

      <div styleName="plans-wrapper">
        <div styleName="title">
          <h1>Subscribe to Open Magazine</h1>
          <br />
          Now open more than just your mind!
        </div>
        <div styleName="sub-title">
          Unlock premium news content and stay informed with our exclusive subscription plan. Get access to in-depth
          stories and expert analysis.
        </div>
        <Link styleName="read-magazine" href="https://emagazine.openthemagazine.com">
          Read E-Magazine <SvgIconHandler type="read-more-arrow" width="18" height="18" viewBox="0 0 24 24" />
        </Link>
        <Plans selectedPlanId={selectedPlanId} onSelectPlan={setSelectedPlanId} />
      </div>
      <div styleName="form-details">
        <div styleName="details-title" id="details-section">
          Enter Your Details
        </div>
        <div styleName="tabs">
          <div styleName={`tab ${activeTab === "new" ? "active-tab" : ""}`} onClick={() => setActiveTab("new")}>
            New Subscription
          </div>
          <div styleName={`tab ${activeTab === "renew" ? "active-tab" : ""}`} onClick={() => setActiveTab("renew")}>
            Renew Subscription
          </div>
        </div>
        <div>
          {activeTab === "new" ? (
            <NewSubscriptionForm selectedPlanId={selectedPlanId} />
          ) : (
            <ReNewSubscriptionForm selectedPlanId={selectedPlanId} />
          )}
        </div>
      </div>
    </div>
  );
};

export { SubscribePage };
